import Lottie from 'lottie-react';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import eye from '../../../styles/lottie/eye.json';
import eyeOff from '../../../styles/lottie/eye-off.json';
import loadingLottie from '../../../styles/lottie/loading.json';
import cgu from '../../../pdf/CGU.pdf';
import confidentialite from '../../../pdf/politique.pdf';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handleLogin } from '../../../utils/LoginService';

const Email = (
  {
    user,
    cartItems,
    resetEmail,
    axiosInstance,
  },
  ref,
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [pw1, setPw1] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [createaccountLoading, setCreateaccountLoading] = useState(false);

  useEffect(() => {
    if (resetEmail && resetEmail.length > 0) {
      setEmail(resetEmail);
    }
  }, [resetEmail]);

  const handleForgottenPasswordDisplay = () => {
    navigate('/reset-password');
  };

  useImperativeHandle(ref, () => ({}));

  const handleSignIn = async () => {
    await handleLogin(
      setCreateaccountLoading,
      email,
      pw1,
      user,
      cartItems,
      axiosInstance,
      dispatch,
      navigate,
    );
  };

  const onblurScrolltoTop = () => {
    window.scrollTo(0, 0);
    if (document.getElementById('page_account')) {
      document.getElementById('page_account').scrollTop = 0;
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="w-full h-full createaccount ">
        <div className="groupinput w-full mb-[200px] flex flex-col">
          <div className="inputGroup w-full flex flex-col items-start">
            <label className="text-2xl m-2 mb-4" htmlFor="emailSignIn">
              Email
            </label>
            <input
              className="user_mail_input w-full"
              type="email"
              id="emailSignIn"
              placeholder="Ton email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              onBlur={onblurScrolltoTop}
              onFocus={onblurScrolltoTop}
            />
          </div>
          <div className="inputGroup w-full flex flex-col items-start">
            <label className="text-2xl m-2 mb-4" htmlFor="passwordSignIn">
              Mot de passe
            </label>
            <input
              onFocus={onblurScrolltoTop}
              onBlur={onblurScrolltoTop}
              type={showPassword ? 'text' : 'password'}
              id="passwordSignIn"
              placeholder="Mot de passe"
              value={pw1}
              onChange={(e) => setPw1(e.target.value)}
            />
            <button
              type="button"
              className="absolute top-[48%] right-8 transform -translate-y-1/2"
              onClick={handleTogglePasswordVisibility}
            >
              {showPassword ? (
                <Lottie
                  animationData={eye}
                  loop={false}
                  autoplay={true}
                  style={{ width: '20px', height: '20px' }}
                />
              ) : (
                <Lottie
                  animationData={eyeOff}
                  loop={false}
                  autoplay={true}
                  style={{ width: '20px', height: '20px' }}
                />
              )}
            </button>
            <button
              type="button"
              className=" text-2xl geomanistBold border-b-2 border-green-500 hover:border-green-700 font-black m-2 mt-4 focus:outline-none mb-4"
              onClick={() => handleForgottenPasswordDisplay()}
            >
              Mot de passe oublié ?
            </button>
          </div>
          {createaccountLoading ? (
            <div className="w-full flex justify-center items-center ">
              <Lottie
                animationData={loadingLottie}
                loop={true}
                autoplay={true}
                style={{ width: '100px', height: '100px' }}
              />
            </div>
          ) : (
            <button
              type="button"
              className="payer w-full p-6 my-6 text-3xl geomanistBold"
              onClick={handleSignIn}
            >
              Me connecter
            </button>
          )}

          <div
            style={{ fontFamily: 'Open Sans', fontWeight: 400 }}
            className="top-12 text-center relative"
          >
            <span>En créant un compte j'accepte</span>
            <a href={cgu} target="_blank" rel="noreferrer">
              {' '}
              Conditions Générales d'Utilisation{' '}
            </a>{' '}
            et la{' '}
            <a href={confidentialite} target="_blank" rel="noreferrer">
              politique de confidentialité
            </a>{' '}
            de PikkoPay
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(Email);
